// extracted by mini-css-extract-plugin
export default {"main_css_JP":"FunctionItem_main_css_JP__xhw-u","main_css_svg":"FunctionItem_main_css_svg__RZNRC","main_css_text":"FunctionItem_main_css_text__Av0rr"};